<template>
  <v-dialog :value="value" max-width="600px" @click:outside="closeDialog" class="border-radius">
    <v-card class="px-5 py-6">
      <v-card-title class="headline">
        {{ $t('modules.portalalumno.procedures.retirement.userData.popupTitle') }}
      </v-card-title>

      <v-card-text>
        <p>{{ $t('modules.portalalumno.procedures.retirement.userData.subtitle') }}</p>
      </v-card-text>

      <div class="ml-6">
        <div class=" d-flex">
          <p>
            {{ $t('modules.portalalumno.procedures.retirement.userData.user.userName') }}
          </p>
          <span class="ml-3"> {{ studentUserData.name }} {{ studentUserData.lastname }}</span>
        </div>
        <div class="mb-3 d-flex">
          <p >
            {{ $t('modules.portalalumno.procedures.retirement.userData.user.rut') }}
          </p>
          <span class="ml-3"> {{ studentUserData.identification }}</span>
        </div>
        <TelephoneInput
          ref="phone"
          v-model="updatedUserData.phone"
          required
          :placeholder="$t('modules.users.update.sectionContact.fields.phone')"
          :label="$t('modules.users.update.sectionContact.fields.cellphone')"
          @blur="$v.updatedUserData.phone.$touch()"
        />

        <v-text-field
          ref="email"
          v-model="updatedUserData.email"
          class="my-3"
          outlined
          type="text"
          :label="$t('modules.portalalumno.procedures.retirement.userData.user.email')"
          :error-messages="emailErrors"
          @blur="$v.updatedUserData.email.$touch()"
        />
      </div>

      <v-card-actions class="d-flex justify-end ma-0 mt-6 pa-0">
        <v-spacer></v-spacer>
        <Button
          color="primary"
          class="mr-6"
          outlined
          @clicked="closeDialog"
          :text="$t('actions.cancel')"
        />
        <Button
          color="primary"
          @clicked="confirm"
          :text="$t('modules.portalalumno.procedures.retirement.userData.confirmUserData')"
          :disabled="$v.$invalid"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators';
import Button from '@/components/Button/Button';
import TelephoneInput from '@/components/TelephoneInput/TelephoneInput';

export default {
  name: 'UserDataPopUp',
  components: {
    Button,
    TelephoneInput
  },
  props: {
    value: Boolean,
    studentUserData: { type: Object, required: true },
    userDataUpdate: { type: Object, required: true },
  },
  data() {
    return {
      updatedUserData: {
        phone: this.userDataUpdate.phone || '',
        email: this.userDataUpdate.email || '',
      }
    };
  },
  watch: {
    userDataUpdate: {
      handler(newVal) {
        if (newVal) {
          this.updatedUserData.phone = newVal.phone || '';
          this.updatedUserData.email = newVal.email || '';
        }
      },
      deep: true,
      immediate: true
    }
  },
  validations: {
    updatedUserData: {
      phone: {
        required,
      },
      email: { required, email },
    }
  },
  computed: {
    emailErrors() {
      const errors = [];
      if (!this.$v.updatedUserData.email.$dirty) return errors;
      if (!this.$v.updatedUserData.email.required) errors.push(this.$t('validation.required'));
      if (!this.$v.updatedUserData.email.email) errors.push(this.$t('validation.invalidEmail'));
      return errors;
    }
  },
  methods: {
    closeDialog() {
      this.$emit('input', false);
    },
    confirm() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      this.$emit('confirm', { ...this.updatedUserData });
      this.closeDialog();
    }
  }
};
</script>

<style scoped>
.headline {
  font-weight: bold;
}
.error--text {
  color: red;
  font-size: 0.875rem;
}
</style>
